export default function literalsSelector(state: any) {
  return state.literals;
}
